<template lang="pug">
    .columns.is-vcentered.is-mobile.outline(
      tabindex="-1"
      v-focus
      @keyup.esc="redirecionarParaTelaDeMarcacao"
    )
      .container.column.p0
        h1.has-text-centered {{ $t('componentes.marcacao.views.historicoMarcacao.titulo') }}
        br(aria-hidden="true")
        template(v-if="!historicoMarcacoes.length")
          .columns.is-centered.has-text-centered
            img(:src="require('../../../../static/images/sem-historico.svg')")
          p.has-text-centered {{ $t('componentes.marcacao.views.historicoMarcacao.semRegistroDePonto') }}
          br(aria-hidden="true")
          .columns.is-centered
            .column.is-three-quarters
              Button3d(color="info" size="medium" :block="true" @click="redirecionarParaTelaDeMarcacao") {{ $t('componentes.marcacao.views.historicoMarcacao.botaoVoltar') }}
        template(v-else)
          .columns.is-centered
            .column.is-three-quarters
              .marcacoes-wrapper
                .marcacoes-container(v-for="marcacao in historicoMarcacoes")
                  h3.has-text-centered {{marcacao.dia}} | {{marcacao.diaDaSemana}}

                  div(style="overflow: scroll; max-height: 120px;")
                    .pt-container(v-for="marcacao in marcacao.marcacoes", :class="marcacao.cor")
                      label.pts-box {{ marcacao.horario }}
                      label.pts-box {{ formatarMomentoDaJornada(marcacao.momentoMarcacao) }}
                      button(
                        v-if="marcacao.botao.download"
                        tabindex="-1"
                        :class="[marcacao.botao.icone, 'botao-download']"
                        @click="fazerDownloadDoComprovante(marcacao)"
                        :aria-label="marcacao.botao.title"
                        :title="marcacao.botao.title"
                        style="border: 0; color: white;"
                      )
                      span(
                        v-else
                        :class="[marcacao.botao.icone, 'ponto-manual']"
                        :aria-label="marcacao.botao.title"
                        :title="marcacao.botao.title"
                      )
          .columns.is-centered
            .column.is-three-quarters
              Button3d(
                color="info",
                size="medium",
                :block="true",
                @click="redirecionarParaTelaDeMarcacao"
              ) {{ $t('componentes.marcacao.views.historicoMarcacao.botaoVoltar') }}
</template>

<script>
import { removerTimezoneOffSet } from '../../../utils'
import { formatarMomentoDaJornada } from '../utils'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'HistoricoMarcacao',
  data () {
    return {
      temporizadorRedirecionamentoPin: null
    }
  },
  computed: {
    ...mapGetters(['visual']),
    historicoMarcacoes () {
      const marcacoes = this.$store.getters['sincronizador/marcacoesAgrupadasETratadas']

      const diasDaSemana = [
        this.$t('componentes.marcacao.views.historicoMarcacao.diasDaSemana.domingo'),
        this.$t('componentes.marcacao.views.historicoMarcacao.diasDaSemana.segunda'),
        this.$t('componentes.marcacao.views.historicoMarcacao.diasDaSemana.terca'),
        this.$t('componentes.marcacao.views.historicoMarcacao.diasDaSemana.quarta'),
        this.$t('componentes.marcacao.views.historicoMarcacao.diasDaSemana.quinta'),
        this.$t('componentes.marcacao.views.historicoMarcacao.diasDaSemana.sexta'),
        this.$t('componentes.marcacao.views.historicoMarcacao.diasDaSemana.sabado')
      ]
      const classes = {
        Entrada: 'success',
        Pausa: 'info',
        'Retorno Pausa': 'warning',
        Saída: 'danger',
        null: 'fallback'
      }

      const retornarBotaoDeAcordoComOrigem = (origem) => {
        const botaoOrigemREPP = {
          icone: 'icone-linha-download',
          title: this.$t('componentes.marcacao.views.historicoMarcacao.botoesOrigem.pontoDownloadComprovante'),
          cursor: 'pointer',
          download: true
        }
        const botaoOrigemOutro = {
          icone: 'icone-linha-relogio',
          title: this.$t('componentes.marcacao.views.historicoMarcacao.botoesOrigem.pontoSemComprovante'),
          cursor: '',
          download: false
        }
        const botaoOrigemCorrecao = {
          ...botaoOrigemOutro,
          title: this.$t('componentes.marcacao.views.historicoMarcacao.botoesOrigem.pontoManual')
        }

        return {
          'REPP': botaoOrigemREPP,
          'OUTRO': botaoOrigemOutro,
          'CORRECAO': botaoOrigemCorrecao
        }[origem]
      }

      const result = marcacoes.map(jornada => {
        const data = moment(jornada[0], 'DD/MM/YYYY')
        const novaData = new Date(data)

        return {
          dia: jornada[0],
          diaDaSemana: diasDaSemana[novaData.getDay()],
          marcacoes: jornada[1]
            .map(i => {
              const origemDiferenteRepp = i.origem !== 'REPP'
              const data = origemDiferenteRepp ? moment(i.horario) : moment.utc(removerTimezoneOffSet(i.horario))
              return {
                ...i,
                dataSemFormatacao: data,
                horario: `${moment(data).format('HH:mm')}`,
                cor: this.getColor(i, classes),
                momentoMarcacao: i.momento_da_jornada ? i.momento_da_jornada.split(' ')[0] : '',
                botao: retornarBotaoDeAcordoComOrigem(i.origem)
              }
            }).sort((a, b) => moment(new Date(a.dataSemFormatacao)).diff(moment(new Date(b.dataSemFormatacao))))
        }
      }).sort((a, b) => moment(b.dia, 'DD/MM/YY').diff(moment(a.dia, 'DD/MM/YY')))

      return result.slice(0, 31)
    }
  },
  methods: {
    getColor (point, classes) {
      if (this.visual.webRegistedByType) {
        if (point.origem !== 'REPP') {
          return this.visual.webRegistedManual
        } else {
          return this.visual.webRegistedTl
        }
      } else {
        return classes[point.momento_da_jornada]
      }
    },
    fazerDownloadDoComprovante (marcacao) {
      if (!marcacao.botao.download) return
      this.$store.dispatch('marcacao/buscarComprovanteMarcacaoPdf', {id: marcacao.id})
    },
    redirecionarParaTelaDeMarcacao () {
      this.$router.push({ name: 'marcacao' })
    },
    iniciarTemporizadorDeRedirecionamentoParaPin () {
      this.temporizadorRedirecionamentoPin = setTimeout(() => {
        this.$router.push({name: 'sincronizador'})
      }, 360000)
    },
    formatarMomentoDaJornada: (momentoDaJornada) => { return formatarMomentoDaJornada(momentoDaJornada) }
  },
  mounted () {
    const ehColetorSSO = this.$store.getters['ehColetorSSO']

    if (!ehColetorSSO) {
      this.iniciarTemporizadorDeRedirecionamentoParaPin()
    }
  },
  beforeDestroy () {
    if (this.temporizadorRedirecionamentoPin) {
      clearInterval(this.temporizadorRedirecionamentoPin)
    }
  }
}
</script>
<style scoped>
.outline {
  outline: none;
}
.marcacoes-wrapper {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 20px;
  row-gap: 20px;
}
.botao-download {
  background-color: transparent !important;
  margin:0 !important;
  padding:0 !important;
  border:0 !important;
  color: white !important;
}
.ponto-manual {
  color: white;
  text-align: center;
}
.pt-container {
  display: grid;
  color: #fff;
  margin-bottom: 2%;
  grid-template-columns: 1fr 1fr 0.4fr;
  align-items: center;
}
.pt-container.success {
  background-color: var(--color-success);
  color: #fff;
}
.pt-container.info {
  background-color: var(--color-info);
  color: var(--color-primary);
}
.pt-container.warning {
  background-color: var(--color-warning);
  color: var(--color-primary);
}
.pt-container.danger {
  background-color: var(--color-danger);
  color: #fff;
}
.pt-container.fallback {
  background-color: #c4c4c4;
  color: var(--color-primary);
}

.icone-linha-download,
.icone-linha-erro {
  text-align: center;
}

.icone-linha-download {
  cursor: pointer;
}

.pts-box {
    margin-top: 2px;
    margin-left: 5%;
  }

</style>
